import { render } from "./RGBColorInput.vue?vue&type=template&id=e8723bc2"
import script from "./RGBColorInput.vue?vue&type=script&lang=js"
export * from "./RGBColorInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__